import apiClient from '../server';

// Backoffice wrappers for the RA city-mapping endpoints on the api-gateway
// clubs-scraper module. These manage which cities are part of the scraper
// roster ("All RA-mapped"): map a city to an RA area + enable it, or remove it.

/**
 * Search RA areas by name (for the picker).
 * @param {string} q
 * @returns {Promise<Array<{id,name,urlName,countryUrlCode,countryName}>>}
 */
export const searchRaAreas = async (q) => {
  const res = await apiClient.get('/admin/clubs-scraper/ra-areas/search', {
    params: { q },
  });
  return res.data;
};

/**
 * List every city with its RA mapping status.
 * @returns {Promise<Array<{_id,name,isEnabled,raAreaId,raAreaName,raAreaUrlName,raCountryUrlCode,mappedVia}>>}
 */
export const listRaCities = async () => {
  const res = await apiClient.get('/admin/clubs-scraper/cities');
  return res.data;
};

/**
 * Map a city to an RA area and enable it (adds it to the scraper roster).
 * @param {string} cityId
 * @param {{raAreaId:string, raAreaName?:string, raAreaUrlName?:string, raCountryUrlCode?:string}} mapping
 */
export const saveCityRaMapping = async (cityId, mapping) => {
  const res = await apiClient.post(
    `/admin/clubs-scraper/cities/${cityId}/ra-mapping`,
    mapping,
  );
  return res.data;
};

/**
 * Enable/disable a city (roster on/off). Keeps the RA mapping intact.
 * @param {string} cityId
 * @param {boolean} enabled
 */
export const setCityEnabled = async (cityId, enabled) => {
  const res = await apiClient.post(
    `/admin/clubs-scraper/cities/${cityId}/enabled`,
    { enabled },
  );
  return res.data;
};

/**
 * Remove a city from the scraper (clears its RA mapping + disables it).
 * @param {string} cityId
 */
export const deleteCityRaMapping = async (cityId) => {
  const res = await apiClient.delete(
    `/admin/clubs-scraper/cities/${cityId}/ra-mapping`,
  );
  return res.data;
};

/**
 * One-time: copy the hardcoded RA mappings onto matching City docs so the whole
 * roster lives in the DB and is editable from the list.
 * @param {boolean} [dryRun=false]
 */
export const backfillRaMappings = async (dryRun = false) => {
  const res = await apiClient.post(
    '/admin/clubs-scraper/cities/backfill-ra-mappings',
    null,
    { params: { dryRun: dryRun ? 'true' : 'false' } },
  );
  return res.data;
};
